export default "__VITE_ASSET__3ded7b5b__"